import type { Iban } from "@/features/user/types";
import { type UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { IbanApiClient } from "../api-client/api-client";
import { useCompanyContext } from "@/features/company/hooks/use-company-context";
import { CheckValidationIban } from "../../quiz/types";
import { QueryOptionsFactory } from "@/features/company/utils";

export default function useCreateIban(
  options?: UseMutationOptions<CheckValidationIban | null, Error, Iban>
) {
  const queryClient = useQueryClient();
  const { leUuid } = useCompanyContext();
  return useMutation<CheckValidationIban | null, Error, Iban>({
    mutationFn: async (iban) => {
      return await IbanApiClient.create(iban, leUuid ?? undefined);
    },
    onSuccess: () =>
      leUuid
        ? queryClient.invalidateQueries({
            queryKey: QueryOptionsFactory.legalEntity(leUuid ?? "").queryKey
          })
        : queryClient.invalidateQueries({ queryKey: ["user", "profile"] }),

    ...options
  });
}
